import * as React from 'react';
export type NLSCheckBoxPropsType = {
  defaultValue: boolean | string;
  name: string;
  label: string;
  register: any;
  checked: boolean;
};
export const NLSCheckBox = ({
  defaultValue,
  name,
  label,
  register,
  checked,
}: NLSCheckBoxPropsType) => {
  return (
    <div className="mb-4">
      <label
        className="block text-gray-700 text-sm font-bold mb-2"
        htmlFor={name}
      >
        {label}
      </label>
      <input
        id={name}
        name={name}
        type="checkbox"
        defaultValue={defaultValue}
        checked={checked ? 'checked' : ''}
        {...register(name)}
      />
    </div>
  );
};
